import { RX } from './constants';
import { RX as globalRX } from '../constants'
import utils from './utils';
import initAuthenticationRepository from './authenticationRepository';

const initAuthenticationRx = (flex, authenticationManager, FlexApiRequest = window.FlexApiRequest) => {

    const authenticationRepository = initAuthenticationRepository(FlexApiRequest);
    const { getTokensFromHtml, makeStateString, restoreStateFromUrl } = utils(flex);

    flex.onTrigger(RX.RUN_AUTHORIZATION_CODE_FLOW, (params) => {
        const redirectUrl = flex.getRedirectUrl() || '/';
        const stateString = makeStateString({ redirectUrl });
        const { adaptor } = params;

        authenticationManager.runAuthorizationCodeFlow(stateString, adaptor);
    });

    flex.onTrigger(RX.RUN_CALLBACK_FLOW, () => {
        return Promise.resolve()
            .then(() => {
                return getTokensFromHtml();
            })
            .then((tokens) => {
                return authenticationRepository.authenticate(tokens.accessToken, tokens.refreshToken)
                    .then((session) => [tokens, session]);
            })
            .then(([tokens, session]) => {
                return new Promise((resolve) => {
                    flex.trigger(globalRX.GLOBAL.SESSION_LOGGED_IN, { session, then: resolve});
                    flex.trigger("global:save-orguser-selected-language", session.token);
                })
                .then(() => tokens);
            })
            .then((tokens) => {
                flex.setCookie({ key: "flex-st", value: tokens.accessToken })
                return authenticationManager.storeTokens(tokens);
            })
            .then(() => {
                const state = restoreStateFromUrl();
                flex.redirect(state.redirectUrl || '/');
            })
            .catch(({ handledErrors, message }) => {
                const timeout = 5000;
                let errorMessage;
                let redirectUrl;

                if (message) {
                    errorMessage = `Error message: ${message}`;
                } else if (handledErrors && handledErrors.length) {
                    errorMessage = _.map(handledErrors, (e) => { return e.summary; }).join(', ');
                    redirectUrl = _.map(handledErrors, (e) => { return e.redirectUrl; }).join(', ');
                } else {
                    errorMessage = 'An error has occurred.';
                }

                console.log(errorMessage);

                flex.addPageAlerts({
                    className: 'alert-danger',
                    summary: `${errorMessage}</br>Redirect in ${timeout/1000}s.`,
                    selfCloseTimeout: timeout
                });

                return new Promise((resolve) => {
                    setTimeout(resolve, timeout);
                }).then(() => {
                    if (redirectUrl) {
                        flex.redirect(redirectUrl);
                    }
                    else {
                        flex.redirect('/');
                    }
                    
                });
            });
    });

    flex.onTrigger(RX.DISPLAY_TOKENS, () => {
        const tokensModel = authenticationManager.getTokens();

        if (!tokensModel) {
            return;
        }

        const summary = `Token type: ${tokensModel.tokenType};\nAccess token: ${tokensModel.accessToken};\nRefresh token: ${tokensModel.refreshToken}`;

        flex.addPageAlerts({ className: 'alert-success', summary: summary, selfCloseTimeout: 60000 });
    });
};

export {
    initAuthenticationRx
};